function init_markets_fix()
{
    //IF Not IE6 Set bottom skyscraper ad on homepage to fixed when top of ad meets window scrolling down
    var msie6 = $.browser == 'msie' && $.browser.version < 7;
    if (!msie6) {
        
        //get left position of left column(visible on page load/ready) 
        var top_sky_pos = 0;
        if( $("#most-read-box").length > 0 ) {
            top_sky_pos = $("#most-read-box").position();
        }

        $(window).on('scroll', function (event) {
            if( $('.skyscraper-wrapper').length  == 0 ){
                return;
            }

            var y = $(this).scrollTop();
            var top_sky_pos = $(".skyscraper-wrapper").position();
            var top_sky_left = (top_sky_pos.left+20)+"px";
            var top = top_sky_pos.top + 20;

            if (y >= top) {
                $('#scrollable_box').addClass('fixed');
                //set left position of ad to account for responsive site that is centered
                $("#scrollable_box.fixed").css({
                    "left" : top_sky_left
                });

            }else {
                $('#scrollable_box').removeClass('fixed');
            }
        });

    }
}

export default init_markets_fix;